module.exports = __webpack_public_path__ + "static/img/Banner.653e308.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Banner.png
// module id = Z4PN
// module chunks = 52